import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import {
    addToWaitingList as addToWaitingListAction,
    getRelatedProducts as getRelatedProductsAction,
} from 'ggApp/modules/product/actions';
import { addNotification as addNotificationAction } from 'ggApp/modules/notification/actions';
import { relatedProductsBySlug } from 'ggApp/modules/product/selectors';
import { keys } from 'ggApp/modules/translator/selectors';

import { UnavailableCard } from './UnavailableCard';

const enhanced = compose(
    connect(
        createStructuredSelector({
            translationKeys: keys,
            relatedProducts: relatedProductsBySlug,
        }),
        (dispatch) => ({
            addToWaitingList: bindActionCreators(addToWaitingListAction, dispatch),
            addNotification: bindActionCreators(addNotificationAction, dispatch),
            getRelatedProducts: (slug) => dispatch(getRelatedProductsAction(slug)),
        }),
    ),
)(UnavailableCard);

export { enhanced as UnavailableCard };
